import React from 'react';
import styled from 'styled-components';

import CardContainer from './components/CardContainer';
import Thumbnail from './components/Thumbnail';
import Title from './components/Title';
import ContentDestination from './components/ContentDestination';

import flexbox from 'styles/utils/flexbox';

const DestinationCardMobile = ({ thumbnail, title, countHotels, slug }) => (
  <CardContainer slug={slug}>
    <Thumbnail src={thumbnail} />
    <Content>
      <Title title={title} />
      <ContentDestination numberOfHotels={countHotels} />
    </Content>
  </CardContainer>
);

export default DestinationCardMobile;

const Content = styled.div`
  ${flexbox({
    justifyContent: 'space-between',
  })}

  width: 100%;
`;
